module.exports = __webpack_public_path__ + "img/ci_bg.48e9bcee.png";